/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Minimum_Duration_SecondsInputs */

const en_minimum_duration_seconds = /** @type {(inputs: Minimum_Duration_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimum Duration (Seconds)`)
};

const fr_minimum_duration_seconds = /** @type {(inputs: Minimum_Duration_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durée minimale (secondes)`)
};

const de_minimum_duration_seconds = /** @type {(inputs: Minimum_Duration_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mindestdauer (Sekunden)`)
};

const it_minimum_duration_seconds = /** @type {(inputs: Minimum_Duration_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durata minima (secondi)`)
};

const ru_minimum_duration_seconds = /** @type {(inputs: Minimum_Duration_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Минимальная продолжительность (в секундах)`)
};

const es_minimum_duration_seconds = /** @type {(inputs: Minimum_Duration_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duración mínima (segundos)`)
};

const zh_cn2_minimum_duration_seconds = /** @type {(inputs: Minimum_Duration_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最短持续时间（秒）`)
};

const ja_minimum_duration_seconds = /** @type {(inputs: Minimum_Duration_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最小継続時間（秒）`)
};

const hi_minimum_duration_seconds = /** @type {(inputs: Minimum_Duration_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`न्यूनतम अवधि (सेकंड)`)
};

const pt_pt2_minimum_duration_seconds = /** @type {(inputs: Minimum_Duration_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duração mínima (segundos)`)
};

/**
* | output |
* | --- |
* | "Minimum Duration (Seconds)" |
*
* @param {Minimum_Duration_SecondsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const minimum_duration_seconds = /** @type {((inputs?: Minimum_Duration_SecondsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Minimum_Duration_SecondsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_minimum_duration_seconds(inputs)
	if (locale === "de") return de_minimum_duration_seconds(inputs)
	if (locale === "it") return it_minimum_duration_seconds(inputs)
	if (locale === "ru") return ru_minimum_duration_seconds(inputs)
	if (locale === "es") return es_minimum_duration_seconds(inputs)
	if (locale === "zh-CN") return zh_cn2_minimum_duration_seconds(inputs)
	if (locale === "ja") return ja_minimum_duration_seconds(inputs)
	if (locale === "hi") return hi_minimum_duration_seconds(inputs)
	if (locale === "pt-PT") return pt_pt2_minimum_duration_seconds(inputs)
	return en_minimum_duration_seconds(inputs)
});